module.exports = __webpack_public_path__ + "img/FroSmokes@2x.3e46bf56.png";